module.exports = __webpack_public_path__ + "static/media/ginger_kowal.204d8c99.jpg";